import { render, staticRenderFns } from "./IdpSamlXml.vue?vue&type=template&id=2edae1a0&scoped=true"
import script from "./IdpSamlXml.vue?vue&type=script&lang=js"
export * from "./IdpSamlXml.vue?vue&type=script&lang=js"
import style0 from "./IdpSamlXml.vue?vue&type=style&index=0&id=2edae1a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edae1a0",
  null
  
)

export default component.exports